import React, { createContext, useContext, useState, useMemo } from 'react';
import { jwtDecode } from 'jwt-decode';

const NavBarContext = createContext();

// Custom hook to use the NavBarContext
export const useNavBar = () => {
  const context = useContext(NavBarContext);
  if (!context) {
    throw new Error('useNavBar must be used within a NavBarProvider');
  }
  return context;
};

// Provider component
export const NavBarProvider = ({ children }) => {
  const [activeButton, setActiveButton] = useState(null);
  const [navbarDisplayName, setNavbarDisplayName] = useState('');
  const [nipCount, setNip] = useState(0);
  const [usaCount, setUSA] = useState(0);
  const [gloCount, setGlo] = useState(0);
  const [vCount, setV] = useState(0);
  const [searchedListName, setSearchListName] = useState('-');
  const [activeSideButton, setActiveSideButton] = useState(() => {
  try {
    const raw = localStorage.getItem("user2026");
    if (!raw) return '';
    const u = jwtDecode(raw);
    return u?.showCalendar === '-' ? '' : u?.showCalendar;
  } catch {
    return '';
  }
});

  const [isPillSelected, setIsPillSelected] = useState(false);
  const [whichOneLine, setWhichOneLine] = useState("Main");

  const updateNavbarDisplayName = (id) => setNavbarDisplayName(id);
  const handleButtonClick = (button) => {setActiveButton((prev) => (prev === button ? null : button));};
  const updateNip = (n) => setNip(n);
  const updateUSA = (u) => setUSA(u);
  const updateGlo = (g) => setGlo(g);
  const updateV = (v) => setV(v);
  const updateSearchedListName = (v) => setSearchListName(v);
  const updateActiveSideButton= (v) => setActiveSideButton(v);
  const updateIsPillSelected = (value) => setIsPillSelected(value);
  const updateWhichOneLine = (value) => setWhichOneLine(value);

  // Memoize the context value
  const value = useMemo(() => ({
    activeButton,
    handleButtonClick,
    navbarDisplayName,
    updateNavbarDisplayName,
    nipCount,
    updateNip,
    usaCount,
    updateUSA,
    gloCount,
    updateGlo,
    vCount,
    updateV,
    searchedListName,
    updateSearchedListName,
    activeSideButton,
    updateActiveSideButton,
    isPillSelected,
    updateIsPillSelected,
    whichOneLine,
    updateWhichOneLine,
  }), [activeButton, navbarDisplayName,nipCount,usaCount,gloCount,vCount,searchedListName,activeSideButton,isPillSelected,whichOneLine]);

  return (
    <NavBarContext.Provider value={value}>
      {children}
    </NavBarContext.Provider>
  );
};


